import React, { useContext, useEffect } from 'react';
import { ActionBar } from 'common';
import * as R from 'ramda';
import { CreateCustomerAuthContext } from '../Create';
import InformationForm from './InformationForm';
import CustomerForm from './CustomerForm';
import TitleBar from '../TitleBarConnector';

const Step1 = () => {
  const { info, setIsNavHidden } = useContext(CreateCustomerAuthContext);

  const { authorizationType, authorizationVolume, customerName, renewalVolume } = info;
  const isAuthVolNeeded = R.not(['ONELOAD', 'UNLIMITED', 'SPECIFIC'].includes(authorizationType));
  const isRenewalVolNeeded = R.not(
    ['LIMITED', 'ONELOAD', 'ONETIME', 'UNLIMITED', 'SPECIFIC'].includes(authorizationType)
  );
  const authVol = R.and(isAuthVolNeeded, R.gt(authorizationVolume, 0)) ? authorizationVolume : null;
  const renewalVol = R.and(isRenewalVolNeeded, R.gt(renewalVolume, 0)) ? renewalVolume : null;
  const form = [authorizationType, customerName];
  const formValidation =
    isAuthVolNeeded && isRenewalVolNeeded
      ? R.concat(form, [authVol, renewalVol])
      : isAuthVolNeeded && !isRenewalVolNeeded
      ? R.concat(form, [authVol, renewalVol])
      : form;
  const notEmpty = R.and(R.isEmpty, R.isNil);
  const mapped = R.filter(R.equals(false), R.map(notEmpty, formValidation));
  const comparisonNum =
    isAuthVolNeeded && isRenewalVolNeeded ? 4 : isAuthVolNeeded && !isRenewalVolNeeded ? 3 : 2;
  const disableContinue = R.not(R.equals(R.length(mapped), comparisonNum));

  const handleBack = () => {
    setIsNavHidden(false);
  };

  // Handling back button click from browser navigation
  useEffect(() => {
    return () => setIsNavHidden(false);
  }, [setIsNavHidden]);

  return (
    <>
      <TitleBar />
      <InformationForm />
      <CustomerForm />
      <ActionBar
        backLink="../.."
        continueLink="../terminals-products"
        disableAction={disableContinue}
        handleBack={handleBack}
      />
    </>
  );
};

export default Step1;
